<!--
 * @Author: your name
 * @Date: 2021-12-05 22:55:23
 * @LastEditTime: 2021-12-10 19:13:29
 * @LastEditors: wintelsui
 * @Description: 
 * @FilePath: /homeweb/src/views/Home/Home.vue
-->
<template>
  <div class="home">
    <div class="base-view">
      <div class="content-view">
        <div class="top-view-background-image">
             <h1 style="color:#FFF">Welcome to wintelsui's home page!</h1>
             <span class="byline" style="color:#FFF">let hello = ["hello","你好","Bonjour","Hola","Buon Giorno","こんにちは"]<br>let description = "我是一个喜欢技术的iOS开发者，喜欢分享，喜欢技术交流学习"</span>
             <br><a href="http://github.com/wintelsui" style="color:#FFF">Github Repo</a>
        </div>  
      </div>
    </div>
  </div>
</template>

<script src="./_Home.js" lang="js"></script>

<style lang="scss" scoped>
  @import "./_Home.scss";
</style>
